import React from 'react';

const WorkHistoryListing = ({ data, onEdit, onDelete, isLoading }) => {
    const formatDate = (dateStr, accuracy) => {
        if (!dateStr) return 'Hiện tại';
        const parts = dateStr.split('-');
        if (parts.length !== 3) return dateStr;

        const [year, month, day] = parts;
        if (accuracy === 'year') return year;
        if (accuracy === 'month') return `${month}-${year}`;
        return `${day}-${month}-${year}`;
    };

    return (
        <div className="table-card">
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <i className="fa-solid fa-circle-notch fa-spin"></i> Đang tải dữ liệu
                </div>
            ) : data.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666' }}>
                    <i className="fa-solid fa-briefcase" style={{ fontSize: '60px', color: '#5dade2', marginBottom: '15px' }}></i>
                    <h3 style={{ color: '#e74c3c', margin: '0 0 10px 0' }}>Chưa có quá trình công tác</h3>
                </div>
            ) : (
                <div style={{ overflowX: 'auto', width: '100%' }}>
                    <table className="custom-table" style={{ width: '100%', minWidth: '900px' }}>
                        <thead>
                            <tr>
                                <th width="5%" style={{ textAlign: 'center' }}>STT</th>
                                <th width="40%">NƠI CÔNG TÁC</th>
                                <th width="12%" style={{ textAlign: 'center' }}>TỪ NGÀY</th>
                                <th width="12%" style={{ textAlign: 'center' }}>ĐẾN NGÀY</th>
                                <th width="20%">CHỨC VỤ</th>
                                <th width="10%" style={{ textAlign: 'center' }}>CHỨC NĂNG</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={item.Id}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ fontWeight: '500', color: '#0056b3' }}>{item.Workplace}</td>
                                    <td style={{ textAlign: 'center' }}>{formatDate(item.StartDate, item.StartDateAccuracy)}</td>
                                    <td style={{ textAlign: 'center', color: !item.EndDate ? '#27ae60' : 'inherit', fontWeight: !item.EndDate ? 'bold' : 'normal' }}>
                                        {formatDate(item.EndDate, item.EndDateAccuracy)}
                                    </td>
                                    <td>{item.Position || '---'}</td>
                                    <td>
                                        <div className="action-group" style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                            <div className="icon-wrapper edit-wrapper" onClick={() => onEdit(item)} title="Sửa" style={{ cursor: 'pointer' }}>
                                                <i className="fa-solid fa-pen edit-icon"></i>
                                            </div>
                                            <div className="icon-wrapper delete-wrapper" onClick={() => onDelete(item.Id)} title="Xóa" style={{ cursor: 'pointer' }}>
                                                <i className="fa-solid fa-trash delete-icon"></i>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default WorkHistoryListing;